require("!!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\raw-loader\\index.js!C:\\Users\\Pedro\\1-KRAFTI\\MMEGA\\PAINEL\\node_modules\\datatables.net-bs\\js\\dataTables.bootstrap.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/datatables.net-bs/js/dataTables.bootstrap.js
// module id = 347
// module chunks = 16